<template>
  <div style="display:flex; flex-direction: column; align-items: center; width: 100%">


    <div style="display: flex; flex-direction: column; justify-content: center;align-items: center">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-position="left" style="width:300px">
        <el-form-item label="班期名称" prop="classCode" required>
          <el-input type="text" v-model="ruleForm.classCode" placeholder="请输入班期名称"/>
        </el-form-item>

        <el-form-item>
          <el-button type="success" style="margin-top: 60px; width: 200px; background-color: darkcyan"
                     @click="submitForm('ruleForm')">
            下载电子证照头像压缩包
          </el-button>
<!--          <a style="color: #f00;" href="http://x.moshushi.pro/files/certPdf/zip/test.zip"> 下载电子证照头像压缩包</a>-->
<!--          <a style="color: #f00;" :href="url"> 下载电子证照头像压缩包</a>-->
        </el-form-item>
      </el-form>
    </div>

  </div>
</template>

<script>
export default {
  name: "batchDownload",

  data() {
    return {
      url:'',
      loading:null,
      ruleForm: {
        classCode: null,

      },
      rules: {
        classCode: [
          {required: true, message: '请输入班期编号', trigger: 'blur'},
        ],
      },

    }
  },
  mounted() {
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.download()
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },

    download() {
      this.openFullScreen2()
      this.$axios.get(window.SITE_CONFIG['baseUrl'] + `/custom/genCert/batchDownloadHeadImageZip`, {
        params: {
          "classCode": this.ruleForm.classCode,
        }
      }).then(res => {
        console.log(res, 99990)
        this.closeFullScreen()
        if (res.data.code == 0) {

          this.downloadFile(res.data.data)
          this.url = res.data.data
          // this.downloadFile("http://x.moshushi.pro/files/certPdf/zip/test.zip")

        } else {
          this.$message.error(res.data.msg)
        }
        console.log(res)
      }).catch(error =>
        //请求失败，触发catch中的函数 可省略
        console.log(error)
      )
    },

    openFullScreen2() {
      this.loading = this.$loading({
        lock: true,
        text: '下载中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });

    },

    closeFullScreen(){
      this.loading.close();
    },

    async downloadFile(filePath) {
      try {
        const response = await this.$axios.get(filePath, {
          responseType: 'blob', // 表示响应数据是 Blob 对象
        });

        // 创建一个隐藏的 <a> 标签用于触发下载
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        let fileName = filePath.substr(filePath.lastIndexOf('/')+1, filePath.length);
        link.setAttribute('download', fileName); // 设置文件名和扩展名
        document.body.appendChild(link);
        link.click();
        link.remove();
      } catch (error) {
        console.error('下载文件时出错:', error);
      }
    },
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/batchDownloadHeadImageZip.vue